import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@xanadu/ui-shared/components/widgets/Button';

import { dispatch as gtmDispatch } from '@xanadu/ui-shared/interfaces/googleTagManager';
import { track } from '@xanadu/ui-shared/interfaces/woopra';
import { userVirtualPageView as gtmUserVirtualPageView } from '@xanadu/ui-shared/interfaces/googleTagManager/actions';

import styles from './Buttons.module.scss';

const Buttons = ({
  registrationRequest,
  isLoggedIn,
  loginRequest,
  widthSize,
  storedAccountID,
  history: { location }
}) => {
  const isMobile = widthSize <= 768;

  const currentUrl = window.location.href;

  const clickAction = (e) => {
    e.preventDefault();

    gtmDispatch(gtmUserVirtualPageView({
      currentUrl,
      eventName: 'Reg Process',
      virtualPageTitle: 'Step 1 - account',
      virtualPageURL: '/reg/step1/',
      previousURL: `${location.pathname}`,
      clickSource: { clickSource: `mb-join-now-button_${location.pathname}` }
    }));

    track('Registration', 'Registration opened', {
      description: 'header'
    });

    registrationRequest({ show: true, promoRegistrationImage: null, checked: false });
  };

  const navClass = classNames({
    [styles.buttons]: true,
    [styles['buttons--loggedIn']]: isLoggedIn,
  });

  const loginClass = classNames({
    [styles.login]: true,
    '.gtm_cta': true,
  });

  const registerClass = classNames({
    [styles.register]: true,
    [styles['register--hidden']]: !!storedAccountID,
    '.gtm_cta': true,
  });

  return (
    <nav className={navClass}>
      <Button
        className={loginClass}
        buttonType="login"
        sizeType={isMobile ? 'small-mobile' : 'medium'}
        disabled={false}
        success={false}
        dataHook="login-top"
        href="/login"
        onClick={(e) => {
          e.preventDefault();
          // GTM
          gtmDispatch(gtmUserVirtualPageView({
            currentUrl,
            eventName: 'Login Request',
            virtualPageTitle: 'Log In / Sign Up',
            virtualPageURL: '/login/',
            previousURL: `${location.pathname}`,
            clickSource: { clickSource: `mb-join-now-button_${location.pathname}` }
          }));

          track('Marketing', 'Login opened', {
            description: 'header'
          });

          loginRequest();
        }}
      >Log In
      </Button>
      <Button
        className={registerClass}
        buttonType="primary"
        sizeType={isMobile ? 'small-mobile' : 'wide'}
        href="/registration"
        disabled={false}
        success={false}
        onClick={clickAction}
        dataHook="registration-top"
      >
        <span className={styles.label} />
      </Button>
    </nav>
  );
};

Buttons.propTypes = {
  registrationRequest: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  loginRequest: PropTypes.func.isRequired,
  widthSize: PropTypes.number,
  storedAccountID: PropTypes.number,
  history: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }),
};

export default Buttons;